export function TotalEarning() {
    let earningDiv: HTMLElement | null = null;

    function updateTotalEarning(newEarning: string) {
        earningDiv = document.getElementById("total-earning-value");
        earningDiv!.innerText = newEarning;
    }

    function render() {
        return /*html*/`
            <div class="p-4 md:p-5 bg-white border border-gray-200 shadow-sm rounded-xl dark:bg-neutral-800 dark:border-neutral-700">
                <div class="flex flex-row sm:flex-row items-center justify-between gap-6 md:gap-2">
                    <div class="">
                        <div class="text-gray-800 text-3xl md:text-4xl font-semibold dark:text-white" id="total-earning-value">$0</div>
                        <p class="text-gray-500 text-sm md:text-base font-medium dark:text-neutral-500">Credit Earned</p>
                    </div>
                    <div class="">
                        <img src="/images/refer-and-earn.svg" alt="Empty State"
                            class="w-full h-auto max-w-[100px] md:max-w-[150px] mx-auto">
                    </div>
                </div>
            </div>`;
    }

    return { render, updateTotalEarning };
}
